import { Box } from '@mui/material';
import React from 'react';
import { BhiDialog } from 'src/UIKit';
import { BlocklistValidateForm } from '../BlocklistValidateForm';

interface BlocklistValidateDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const BlocklistValidateDialog: React.FC<BlocklistValidateDialogProps> = ({ isOpen, onClose }) => {
  return (
    <BhiDialog
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="md"
      title="Validate Text Against Blocklist"
      paperSx={{ width: '600px' }}
    >
      <Box px={2.5} pb={2.5}>
        <BlocklistValidateForm />
      </Box>
    </BhiDialog>
  );
};
